export default __webpack_public_path__ + "static/media/interest.030b5928.svg";